import React from 'react';
import {
  Banner,
  CondensedHeader,
  DateUtil,
  Gutter,
  IconButton,
  Layout,
  LayoutItem,
  Paragraph,
  useApi,
} from '@axiom/ui';
import type {
  OpportunityCandidate,
  User,
  CandidateRedux,
  Candidate,
} from '@axiom/validation';

import HorizontalRule from '../HorizontalRule/HorizontalRule';
import { CandidateCalendarMenu } from '../CandidateCalendarMenu/CandidateCalendarMenu';
import { CalendarApi } from '../../api/calendar-api';

export const TalentInterviewAvailability = ({
  candidate,
  user,
  opportunityCandidate,
  name,
}: {
  candidate: CandidateRedux | Candidate;
  user: User;
  opportunityCandidate?: OpportunityCandidate;
  name: string;
}) => {
  const [{ data: calendarData } = { data: undefined }] = useApi(
    candidate.calendar?.id
      ? CalendarApi.readCalendar(candidate.calendar.id)
      : undefined
  );
  return (
    <div data-test={name}>
      {candidate.isInterviewAvailabilityOutdated ? (
        <Banner
          name="INTERVIEW_AVAILABILITY_OUTDATED_BANNER"
          impact="high"
          type="critical"
        >
          {candidate.calculatedFirstName} needs more interview availability.
          Please ask them to update their calendar or you can do it on their
          behalf.
        </Banner>
      ) : null}
      <Gutter bottom="32px" />
      <Layout name="INTERVIEW_AVAILABILITY_CONTAINER">
        <LayoutItem fluid>
          <CondensedHeader name="INTERVIEW_AVAILABILITY_HEADER">
            Interview Availability
          </CondensedHeader>
          {!!calendarData?.freeTimeUpdatedAt && (
            <Paragraph name="LAST_UPDATED">
              Last Updated{' '}
              {DateUtil.displayDatestamp(calendarData.freeTimeUpdatedAt)}
            </Paragraph>
          )}
        </LayoutItem>
        <LayoutItem position="right">
          <CandidateCalendarMenu
            opportunityCandidate={opportunityCandidate}
            user={user}
            candidate={candidate}
            icon={
              <IconButton
                icon="calendar"
                variation="minimal"
                pattern="secondary"
              />
            }
          />
        </LayoutItem>
      </Layout>
      <HorizontalRule />
    </div>
  );
};
